import React, { useEffect, useMemo, useRef, useState } from "react";
import Loaders from "../Loaders";
import HeaderTop from "../HeaderTop";
import Menus from "../Menus";
import Footers from "../Footers";
import "../../../libs/css/bootstrap.min3.3.7.css";
import "../../../libs/css/sweetalert2.min.css";
import { API_ROUTES } from "../../../utils/constants";
import Nulls from "../Nulls";
import { format, parseISO } from "date-fns";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Swal from "sweetalert2";
import FilterComponent from "./FilterComponent";
import DataTable from "react-data-table-component";
import FilterComponent3 from "./FilterComponent3";
import { useNavigate } from "react-router-dom";
import { data } from "jquery";

export default function DownloadReport(props) {
  const {
    objectToFormData,
    errorFunction,
    Helmet,
    capitalizeWords,
    isAuthExpired,
    today,
    resetTimeToMidnight,
    resetTimeToB4Midnight,
    formatDate,
    allCPs,
    isLoading1,
    userSessions,
  } = props;

  useEffect(() => {
    document.title = "Report Downloading | Forthsoft";
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const [summaryData, setSummaryData] = useState(null);
  const [dailyBreakdown, setDailyBreakdown] = useState([]);
  const [activeTab, setActiveTab] = useState("summary");
  const [isFade, setIsFade] = useState(false);
  const navigate = useNavigate();
  const clearInputs = useRef(null);

  const TableInput = [
    { id: "1", name: "Charging Report", value: "charging" },
    { id: "2", name: "Subscribers Report", value: "subscriber" },
    { id: "3", name: "Unsubscribers Report", value: "unsubscription" },
  ];

  const userData = JSON.parse(localStorage.getItem("userDataFs"));

  // Summary table columns
  const [selectedType, setSelectedType] = useState("charging");
  const [showTable, setShowTable] = useState(true);
  const summaryColumns = useMemo(() => {
    const baseColumns = [
      {
        name: "ID",
        selector: (row) => row.id,
        sortable: true,
        wrap: true,
      },
      {
        name: "Product ID",
        selector: (row) => row.productId,
        sortable: true,
        wrap: true,
      },
      {
        name: "Service Id",
        selector: (row) => row.serviceId,
        sortable: true,
        wrap: true,
      },
      {
        name: "CP",
        selector: (row) => row.user_name,
        sortable: true,
        wrap: true,
      },
      {
        name: "Total Count",
        selector: (row) => row.totalCount?.toLocaleString(),
        sortable: true,
        wrap: true,
      },
      {
        name: "Total charge Amount",
        selector: (row) => row.totalChargeAmount?.toLocaleString(),
        minWidth: "250px",
        sortable: true,
      },
      {
        name: "Date",
        selector: (row) => row.created_at,
        sortable: true,
      },
    ];

    if (selectedType !== "charging") {
      return [
        {
          name: "ID",
          selector: (row) => row.id,
          sortable: true,
          wrap: true,
        },
        {
          name: "Service Type",
          selector: (row) => row.serviceType || "",
          sortable: true,
          wrap: true,
        },
        {
          name: "Product ID",
          selector: (row) => row.productId,
          sortable: true,
          wrap: true,
        },
        {
          name: "Bearer Id",
          selector: (row) => row.bearerId || "",
          sortable: true,
          wrap: true,
        },
        ...baseColumns.slice(1), // Skip Product ID since we already added it
      ];
    }

    return baseColumns;
  }, [selectedType]);

  const getData = async (dataString) => {
    setIsFade(true);

    try {
      const response = await fetch(API_ROUTES.DOWNLOAD_SUMMARY, {
        method: "POST",
        body: JSON.stringify(dataString),
        headers: {
          token: userData?.responseDetails?.token,
          "Content-Type": "application/json",
        },
      });
      const responseJSON = await response.json();

      isAuthExpired(responseJSON);

      if (responseJSON.status.toString() === "200") {
        const { data } = responseJSON;

        setSummaryData(data);
        // console.log("Summary Data:", data);
        setIsLoading(false);
        setIsFade(false);

        // console.log("Full API Response:", responseJSON.data);
      } else {
        setSummaryData(null);
        setIsLoading(false);
        setIsFade(false);

        Swal.fire({
          title: "No Data",
          text:
            responseJSON.message || "No data found for the selected criteria",
          icon: "info",
        });
      }
    } catch (error) {
      console.log("Error getting data: ", error);
      setSummaryData(null);
      setIsLoading(false);
      setIsFade(false);

      Swal.fire({
        title: "Error",
        text: "Failed to fetch data. Please try again.",
        icon: "error",
      });
    }
  };

  const handleDuration = async (data) => {
    setShowTable(true);

    if (data.type === "") {
      Swal.fire({
        title: "Error",
        text: "Please select a type",
        icon: "error",
      });
      return;
    }

    let dataString = {
      cp_id: Number(data.cp_id) || null,
      type: data.type,
      from: data.from,
      to: data.to,
    };

    getData(dataString);
  };

  // const handleDownload = () => {
  //   if (!summaryData || summaryData.length === 0) {
  //     Swal.fire({
  //       title: "No Data",
  //       text: "There is no data to download. Please apply filters first.",
  //       icon: "warning",
  //     });
  //     return;
  //   }
  //   let headers;

  //   const headers = [
  //     "Service Type",
  //     "Product ID",
  //     "Bearer Id",
  //     "Service Id",
  //     "Total Count",
  //     "Total Charge Amount",
  //     "Date",
  //   ];

  //   const csvRows = [];
  //   csvRows.push(headers.join(","));

  //   summaryData.forEach((row) => {
  //     const values = [
  //       row.serviceType || "Not specified",
  //       row.productId || "",
  //       row.bearerId || "Not specified",
  //       row.serviceId || "",
  //       row.totalCount || 0,
  //       row.totalChargeAmount || 0,
  //       row.created_at || "",
  //     ];

  //     csvRows.push(values.map((val) => `"${val}"`).join(","));
  //   });

  //   const csvString = csvRows.join("\n");

  //   const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  //   const link = document.createElement("a");
  //   const url = URL.createObjectURL(blob);

  //   const date = new Date().toISOString().split("T")[0];
  //   const filename = `summary_report_${date}.csv`;

  //   link.setAttribute("href", url);
  //   link.setAttribute("download", filename);
  //   link.style.visibility = "hidden";
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);

  //   Swal.fire({
  //     title: "Success",
  //     text: "Data downloaded successfully!",
  //     icon: "success",
  //     timer: 2000,
  //     showConfirmButton: false,
  //   });
  // };
  const handleDownload = () => {
    if (!summaryData || summaryData.length === 0) {
      Swal.fire({
        title: "No Data",
        text: "There is no data to download. Please apply filters first.",
        icon: "warning",
      });
      return;
    }

    // Define headers based on selectedType
    const headers =
      selectedType !== "charging"
        ? [
            "ID",
            "Service Type",
            "Product ID",
            "Bearer Id",
            "Service Id",
            "CP",
            "Total Count",
            "Total Charge Amount",
            "Date",
          ]
        : [
            "ID",
            "Product ID",
            "Service Id",
            "CP",
            "Total Count",
            "Total Charge Amount",
            "Date",
          ];

    const csvRows = [];
    csvRows.push(headers.join(","));

    summaryData.forEach((row) => {
      // Define values based on selectedType
      const values =
        selectedType !== "charging"
          ? [
              row.id || "",
              row.serviceType || "Not specified",
              row.productId || "",
              row.bearerId || "Not specified",
              row.serviceId || "",
              row.user_name || "",
              row.totalCount || 0,
              row.totalChargeAmount || 0,
              row.created_at || "",
            ]
          : [
              row.id || "",
              row.productId || "",
              row.serviceId || "",
              row.user_name || "",
              row.totalCount || 0,
              row.totalChargeAmount || 0,
              row.created_at || "",
            ];

      csvRows.push(values.map((val) => `"${val}"`).join(","));
    });

    const csvString = csvRows.join("\n");
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    const date = new Date().toISOString().split("T")[0];
    const filename = `summary_report_${date}.csv`;

    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    Swal.fire({
      title: "Success",
      text: "Data downloaded successfully!",
      icon: "success",
      timer: 2000,
      showConfirmButton: false,
    });
  };
  return (
    <>
      <div className="flapt-page-wrapper mainContent">
        <Menus />

        <div className="flapt-page-content">
          <HeaderTop />

          <div className="main-content introduction-farm mt--20">
            <div className="content-wraper-area">
              <div className="dashboard-area">
                <div className="container-fluid mb-90">
                  <div className="card-header mb--30 mb-xs-10 ml-10">
                    <h2>Summary Download</h2>
                  </div>

                  {isLoading1 ? (
                    <LoadingSpinner />
                  ) : (
                    <>
                      {/* Filter Component */}
                      <FilterComponent3
                        handleDuration={handleDuration}
                        allCPs={allCPs}
                        userSessions={userSessions}
                        networkData={TableInput}
                        isServiceRevenue={true}
                        handleDownload={handleDownload}
                        setSelectedType={setSelectedType}
                        setShowTable={setShowTable}
                      />

                      <div style={{ opacity: isFade ? "0.3" : 1 }}>
                        {/* Tab Content */}
                        <div className="row">
                          <div className="col-12">
                            {activeTab === "summary" &&
                              summaryData &&
                              showTable && (
                                <DataTable
                                  className="revenue_datatable users"
                                  title=""
                                  columns={summaryColumns}
                                  data={summaryData}
                                  highlightOnHover
                                  pagination
                                  paginationPerPage={10}
                                  paginationRowsPerPageOptions={[
                                    10, 20, 30, 50, 100,
                                  ]}
                                />
                              )}

                            {!summaryData && !isLoading && (
                              <div className="mt-20">
                                Please filter on the filter boxes above to
                                populate data
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <Footers />
          </div>
        </div>
      </div>
    </>
  );
}
